import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { errorManagerActions } from "@/business/shared/commons/rest/errorManagerActions";
import { deleteClientUrl } from "@/business/clients/infrastructure/constants/urls";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";

export const deleteClientService = {
  async execute(id: string): Promise<void> {
    const url = getEnvVariable
      .execute("VUE_APP_ADMINISTRATION_URL")
      .concat(deleteClientUrl)
      .replace("{clientId}", id);

    const response: RestResponse = await restClient().sendRequest(
      url,
      "DELETE"
    );

    if (!response.isSuccess) {
      throw errorManagerActions().transformAV(response.content);
    }
  },
};
